Ext.define('SA.view.TableBodyRegions', {
    constructor({borderSizes, rowRegions, colRegions}) {
        this.borderSizes = borderSizes;
        this.rowRegions = rowRegions;
        this.colRegions = colRegions;
    },

    getColIds() {
        return this.colRegions.map(region => region.getColId());
    },

    getPosition() {
        var top = this.rowRegions[0].getTop() - this.borderSizes.getHeight(),  
            left = this.colRegions[0].getLeft() - this.borderSizes.getWidth(); 

        return {top, left};
    },

    getRowIds() {
        return this.rowRegions.map(region => region.getRowId());
    },

    getSize() {
        var width = this.colRegions.at(-1).getRight() + this.borderSizes.getWidth(),    
            height = this.rowRegions.at(-1).getBottom() + this.borderSizes.getHeight(); 

        return {width, height};
    },

    intersectRegion(predicateRegion) {
        var borderSizes = this.borderSizes,
            rowRegions = this.rowRegions.filter(region => region.intersectsRegion(predicateRegion)),
            colRegions = this.colRegions.filter(region => region.intersectsRegion(predicateRegion));

        return new SA.view.TableBodyRegions({borderSizes, rowRegions, colRegions});
    }
});